import "./LabeledTags.scss";
import { createSpreadableBem } from "/Helpers/createBem";
import { TagsColors } from "/App.GeneratedEnums";
import Tags from "./Tags";

interface LabeledTagsProps {
  label?: string;
  categoryTags?: string[];
  color: TagsColors;
}

const LabeledTags = ({ label, categoryTags, color }: LabeledTagsProps) => {
  if (!categoryTags || categoryTags.length === 0) {
    return null;
  }

  const bem = createSpreadableBem("labeled-tags");

  return (
    <div {...bem("")}>
      {label && <span {...bem("__label")}>{label}</span>}
      <Tags categoryTags={categoryTags} color={color} />
    </div>
  );
};

export default LabeledTags;
